import { createSlice } from "@reduxjs/toolkit";

import {
  executeListMachineInfos,
  executeUpdateOfficeInfo,
} from "../api/RemoteMaintenanceApi";
import { storeKeyName } from "../common/AppConstant";
import { handleError } from "../common/ErrorUtil";

/**
 * Slice.
 *
 * @type {object}
 */
export const slice = createSlice({
  // Slice名
  name: storeKeyName.remoteMaintenance,

  // 初期State
  initialState: {
    // 読み込み中フラグ（true: 表示、false: 非表示）
    isLoading: false,
    // エラー内容
    error: null,
    // 機器情報一覧
    machineInfos: [],
  },

  // Reducer
  reducers: {
    // 通信開始
    fetchStart(state) {
      state.isLoading = true;
    },
    // 通信失敗
    fetchFailure(state, action) {
      state.error = action.payload;
      state.isLoading = false;
    },
    // 通信成功
    fetchSuccess(state) {
      state.error = null;
      state.isLoading = false;
    },
    // クリア
    fetchClear(state) {
      state.error = null;
      state.machineInfos = [];
      state.isLoading = false;
    },
    // 機器情報一覧のソート
    fetchSortMachineInfos(state, action) {
      const { column, nextOrder } = action.payload;

      const sortRule = { asc: [1, -1], desc: [-1, 1] };
      const sortMachineInfos = state.machineInfos.sort((a, b) => {
        if (a[column] > b[column]) {
          return sortRule[nextOrder][0];
        }
        if (a[column] < b[column]) {
          return sortRule[nextOrder][1];
        }
        return 0;
      });
      state.machineInfos = sortMachineInfos;
    },
    // 機器情報一覧の更新
    fetchUpdateMachineInfos(state, action) {
      const column = "iotName";
      const nextOrder = "asc";
      const sortRule = { asc: [1, -1], desc: [-1, 1] };
      const sortMachineInfos = action.payload.sort((a, b) => {
        if (a[column] > b[column]) {
          return sortRule[nextOrder][0];
        }
        if (a[column] < b[column]) {
          return sortRule[nextOrder][1];
        }
        return 0;
      });
      state.machineInfos = sortMachineInfos.filter(
        (machine) => machine.iotName !== "-"
      );
    },
  },
});

/**
 * Actions.
 *
 * @type {object}
 */
export const {
  fetchStart,
  fetchFailure,
  fetchSuccess,
  fetchClear,
  fetchSortMachineInfos,
  fetchUpdateMachineInfos,
} = slice.actions;

/**
 * Selectors.
 *
 * @type {function}
 */
export const selector = (stateAll) =>
  // すべてのStoreのStateが含まれているため、特定のStoreのStateのみ返す
  stateAll[storeKeyName.remoteMaintenance];

/**
 * fetchListMachines.
 *
 */
export const fetchListMachines = () => async (dispatch) => {
  // 通信開始
  dispatch(fetchStart());

  // APIの実行
  const { data, error } = await executeListMachineInfos().catch(handleError);
  if (error) {
    dispatch(fetchFailure(error));
    return;
  }

  dispatch(fetchUpdateMachineInfos(data.machineInfos));
  dispatch(fetchSuccess());
};

/**
 * fetchUpdateMachine.
 *
 */
export const fetchUpdateMachine = (payload) => async (dispatch) => {
  // 通信開始
  dispatch(fetchStart());

  // APIの実行
  const { error: officeError } = await executeUpdateOfficeInfo(payload).catch(
    handleError
  );
  if (officeError) {
    dispatch(fetchFailure(officeError));
    return;
  }

  // APIの実行
  const { data, error: listError } = await executeListMachineInfos().catch(
    handleError
  );
  if (listError) {
    dispatch(fetchFailure(listError));
    return;
  }

  dispatch(fetchUpdateMachineInfos(data.machineInfos));
  dispatch(fetchSuccess());
};
